import { Site } from '@envato/foundation-types'

const experimentConfig = {
  authorDiscountingItemsPhase2: {
    experimentId: 'PSyailxsRRm-sLeR-OFg3A',
    running: true,
    loadingCover: true,
    sites: [Site.audiojungle, Site.videohive],
    variants: {
      // A
      0: {
        showPromoItemsBlock: false,
        showSaleMessage1: false,
        showSaleMessage2: false,
        showSaleMessage3: false,
        showWasNowPricing: false,
        showSavingsPercentage: false,
        showSavingsAmount: false
      },
      // B
      1: {
        showPromoItemsBlock: true,
        showSaleMessage1: true,
        showSaleMessage2: false,
        showSaleMessage3: false,
        showWasNowPricing: false,
        showSavingsPercentage: false,
        showSavingsAmount: false
      },
      // C
      2: {
        showPromoItemsBlock: true,
        showSaleMessage1: false,
        showSaleMessage2: true,
        showSaleMessage3: false,
        showWasNowPricing: true,
        showSavingsPercentage: false,
        showSavingsAmount: false
      },
      // D
      3: {
        showPromoItemsBlock: true,
        showSaleMessage1: false,
        showSaleMessage2: true,
        showSaleMessage3: false,
        showWasNowPricing: true,
        showSavingsPercentage: true,
        showSavingsAmount: false
      },
      // E
      4: {
        showPromoItemsBlock: true,
        showSaleMessage1: false,
        showSaleMessage2: true,
        showSaleMessage3: false,
        showWasNowPricing: true,
        showSavingsPercentage: false,
        showSavingsAmount: true
      },
      // F
      5: {
        showPromoItemsBlock: true,
        showSaleMessage1: false,
        showSaleMessage2: false,
        showSaleMessage3: true,
        showWasNowPricing: true,
        showSavingsPercentage: true,
        showSavingsAmount: false
      }
    }
  },
  categoryPageElementsBlockVH: {
    experimentId: 'neL6UBl6QM-075iakKCxUA',
    running: true,
    loadingCover: true,
    sites: [Site.videohive],
    variants: {
      0: {
        categoryPageBlocksB: false
      },
      1: {
        categoryPageBlocksB: false
      },
      2: {
        categoryPageBlocksB: true,
        showOriginalBlock: true
      },
      3: {
        categoryPageBlocksB: true,
        showOriginalBlock: true
      },
      4: {
        categoryPageBlocksB: true,
        showOriginalBlock: true
      },
      5: {
        categoryPageBlocksB: true,
        showOriginalBlock: true
      }
    }
  },
  categoryPageElementsBlockGR: {
    experimentId: '-nbomKMpRo-o422kNe1jpg',
    running: true,
    loadingCover: true,
    sites: [Site.graphicriver],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        showOriginalBlock: true
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        showOriginalBlock: true
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        showOriginalBlock: true
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        showOriginalBlock: true
      }
    }
  },
  categoryPageElementsBlockTF: {
    experimentId: 'tDmLiaB-RACY6uDAIrm2aQ',
    running: true,
    loadingCover: true,
    sites: [Site.themeforest],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        categoryPageBlocksD: false
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        categoryPageBlocksD: false
      },
      6: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: true
      },
      7: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: true
      }
    }
  },
  categoryPageElementsBlockCC: {
    experimentId: 'MAQHi6cdSBO4n4x5qBV8Zg',
    running: true,
    loadingCover: true,
    sites: [Site.codecanyon],
    variants: {
      0: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      1: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      2: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      3: {
        categoryPageBlocksB: true,
        categoryPageBlocksC: false,
        categoryPageBlocksD: false
      },
      4: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        categoryPageBlocksD: false
      },
      5: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: true,
        categoryPageBlocksD: false
      },
      6: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: true
      },
      7: {
        categoryPageBlocksB: false,
        categoryPageBlocksC: false,
        categoryPageBlocksD: true
      }
    }
  },
  homePageTrafficToElementsPhase1: {
    experimentId: 'XG-yGCFBT7GfsMNCiSaLRA',
    running: false,
    loadingCover: true,
    sites: [
      Site.audiojungle,
      Site.codecanyon,
      Site.graphicriver,
      Site.photodune,
      Site.themeforest,
      Site.videohive
    ],
    variants: {
      0: {
        homePageElementsBanner: false,
        homePageElementsBannerAltCTA: false,
        homePageEnvatoProductsBanner: false
      },
      1: {
        homePageElementsBanner: false,
        homePageElementsBannerAltCTA: false,
        homePageEnvatoProductsBanner: false
      },
      2: {
        homePageElementsBanner: true,
        homePageElementsBannerAltCTA: false,
        homePageEnvatoProductsBanner: false
      },
      3: {
        homePageElementsBanner: true,
        homePageElementsBannerAltCTA: false,
        homePageEnvatoProductsBanner: false
      },
      4: {
        homePageElementsBanner: true,
        homePageElementsBannerAltCTA: true,
        homePageEnvatoProductsBanner: false
      },
      5: {
        homePageElementsBanner: true,
        homePageElementsBannerAltCTA: true,
        homePageEnvatoProductsBanner: false
      },
      6: {
        homePageElementsBanner: false,
        homePageElementsBannerAltCTA: false,
        homePageEnvatoProductsBanner: true
      },
      7: {
        homePageElementsBanner: false,
        homePageElementsBannerAltCTA: false,
        homePageEnvatoProductsBanner: true
      }
    }
  }
}

export default experimentConfig
